import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCBPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5189" data-mp="2qrvr1ofi1tom">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5190" data-mp="2vo2yxmrghf97">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5191" data-mp="232jimqrzxpnd">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5192" data-mp="2crb8mtdhxzvn">
              <XIcon className="w-6 h-6" data-id="element-5193" data-mp="1fa33op3k2dsa" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5194" data-mp="1ka8p3nj8f41x">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5195" data-mp="3bhcxy0o87pw2"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5196" data-mp="2nqzc4rw8in9x">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5197" data-mp="2iu8nhg6d6jcw">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5198" data-mp="2erm3g1fxq2q9" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5199" data-mp="26hoeo6vdl65y">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5200" data-mp="21ik5vhcd5ag5">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5201" data-mp="21gh645les2y8">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5202" data-mp="2p97g499r4c5v" />
          <div className="hidden md:block" data-id="element-5203" data-mp="2l6kl5zhsab4g">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5204" data-mp="2l5hzc5zbiyve">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5205" data-mp="x91zwbm82g5g">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5206" data-mp="16ajc3iwidxov">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5207" data-mp="il776v87sbsd">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5208" data-mp="nhffbonzv4q1">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5209" data-mp="2ua5aot8nweul">
        <div className="md:col-span-7" data-id="element-5210" data-mp="2z7wxx9yd3csg">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4 text-center md:text-left" data-id="element-5211" data-mp="339ijdjoyoze9">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight text-center md:text-left" data-id="element-5212" data-mp="3cz228pcoct94">
            Stop Het Blaffen, Trekken en Uitvallen - Zonder Straffen
          </h1>
          <div className="md:hidden mb-6" data-id="element-5213" data-mp="3mxix3xeqhs0g">
            <img src="https://cdn.magicpatterns.com/uploads/qnzT9c8MEjsZMbSpGR8q95/MCC_webinar_preview.png" alt="Webinar preview: Communiceren met je Hond" className="w-full rounded-2xl shadow-lg" data-id="element-5214" data-mp="3mykl12gum8zl" />
          </div>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5215" data-mp="1wkab0fr9ls1e">
            Ja, ik wil dit oplossen →
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5216" data-mp="1fazkkeotpb6x">
            <div className="flex -space-x-3" data-id="element-5217" data-mp="1ba5yzryus8h7">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5218" data-mp="1bbh35sw7ni8u" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5219" data-mp="1yz8f2vdu9t9l" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5220" data-mp="nlwjt8w5aiz1" />
            </div>
            <div data-id="element-5221" data-mp="p1qt4iiw8xny">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5222" data-mp="p05y6rso3cpk">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5223" data-mp="b290tt6e329u">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5224" data-mp="f1htsvtluw4c">
            Ontdek in dit gratis 90-minuten webinar de liefdevolle aanpak
            waarmee duizenden baasjes probleemgedrag hebben opgelost
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5225" data-mp="3nj4iiue76zvi">
            {['Waarom je hond blaft, trekt of uitvalt - en wat hij je écht probeert te vertellen', 'De signalen die je nu mist - waardoor probleemgedrag blijft terugkomen', 'Hoe je angst, stress en onzekerheid herkent - voordat het escaleert', 'Waarom straffen en corrigeren het probleem erger maakt - en wat wél werkt', 'Hoe wandelen weer ontspannen wordt - zonder dat je andere honden moet ontwijken', 'Concrete stappen om vandaag nog te starten met een nieuwe aanpak'].map((item, i) => <li key={i} className="flex items-start" data-id="element-5226" data-mp="38wnuqh4c1lyq" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5227" data-mp="38u2utxnlhg3m" />
                <span className="text-gray-700 font-medium" data-id="element-5228" data-mp="34wwyvyzy8fnc">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5229" data-mp="3dvifholv1klh">
            <div className="flex -space-x-3" data-id="element-5230" data-mp="3duz5qv6d62ij">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5231" data-mp="3sk53eepjzkob" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5232" data-mp="5g8e6ipsojer" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5233" data-mp="1crw8lq5zf9e7" />
            </div>
            <div data-id="element-5234" data-mp="1lqqa9uy66pym">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5235" data-mp="p2k2x09v5jgn">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5236" data-mp="p4ejy3i0krfg">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5237" data-mp="y273jjurql8n">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5238" data-mp="12tylj5zuzin6">
            <div className="flex justify-center items-center w-full" data-id="element-5239" data-mp="12v9pp6x7uset">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5240" data-mp="5djfxhmjrjrx"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5241" data-mp="3g0y50vel59zk">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5242" data-mp="3g2resjkhwabs">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5243" data-mp="3b8wx1loga5fc">
            Los probleemgedrag op in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5244" data-mp="368iom2ixstgs">
            <div className="flex flex-col items-center" data-id="element-5245" data-mp="31d3bxdwo13ly">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5246" data-mp="2x9x96g8rhuk8" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5247" data-mp="1xvab6gxtckgl">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5248" data-mp="1sxsatexv3dk7">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5249" data-mp="27lllqmc05rwg">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5250" data-mp="22milrgavqbvc" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5251" data-mp="1a07ke3fg86xh">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5252" data-mp="1owf3t1j194bp">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5253" data-mp="30a13hgmiqobh">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5254" data-mp="30cn8b8i0ypq0" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5255" data-mp="37ulccxhft8lu">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5256" data-mp="2tutwssb9vk5q">
                Leer in 90 minuten de aanpak die probleemgedrag écht oplost
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5257" data-mp="2xxyw6m0235q5">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5258" data-mp="3gu85yx3xda4c">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5259" data-mp="3gt6reinpa5hv">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5260" data-mp="8e597mecp5us">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-5261" data-mp="n26pzkuvtunb" />
            <span className="italic" data-id="element-5262" data-mp="n0lw7xge6fqi">
              "Wandelen is weer een genot. Eindelijk rust."
            </span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5263" data-mp="e0ysh506wxua">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5264" data-mp="dzdybghsfgwy">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5265" data-mp="91cf8vkd3hlh">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5266" data-mp="3vhyobplfpe30"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5267" data-mp="37dhaboj2r3nf">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5268" data-mp="3cd3oc06q8nxa">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5269" data-mp="3hbohjfnka7c8"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5270" data-mp="25v6vm9hlbn3u">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5271" data-mp="bhkw5u51ghsa">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5272" data-mp="l6ckztesylyz"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5273" data-mp="35x3k91iew6m2">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5274" data-mp="30ys82k4n9k0o">
              <div className="flex items-center mb-4" data-id="element-5275" data-mp="1gfg1roouzh0w">
                <div className="flex text-green-500 mr-2" data-id="element-5276" data-mp="1gi29ppfnvyjn">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5277" data-mp="16pwk2mcvtt7m" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5278" data-mp="1bopxyfw2zm8b">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5279" data-mp="xp859pfnzoto">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5280" data-mp="12m8bc0cikrks">
                In korte tijd zoveel geleerd en handvatten gekregen. We hebben
                herplaatsers, dus we zijn wel wat gewend. Maar nu hebben we
                eindelijk de tools.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5281" data-mp="2i5l5h9ahmk6b">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5282" data-mp="2lmzga5sg6jla">
              <div className="flex items-center mb-4" data-id="element-5283" data-mp="2lkmoz20suwvk">
                <div className="flex text-green-500 mr-2" data-id="element-5284" data-mp="2gmuwa5sbz6qb">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5285" data-mp="2bpl3qh9naey9" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5286" data-mp="27p13v5xosx8f">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5287" data-mp="34cz1uip2xgjy">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5288" data-mp="2zggxvl1kpm8o">
                De tips helpen echt. Ik raad iedereen met hondjes en problemen
                deze cursus aan. Volg de gratis Masterclass en je bent
                overtuigd.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5289" data-mp="3n4ruud45f1ro">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5290" data-mp="3ibf7057amyzz">
              <div className="flex items-center mb-4" data-id="element-5291" data-mp="14wgk9wl75d4k">
                <div className="flex text-green-500 mr-2" data-id="element-5292" data-mp="19sx78ngntlg2">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5293" data-mp="1du91556kgsu2" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5294" data-mp="1iv6i5efubgtz">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5295" data-mp="1nsop4zaarlzc">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5296" data-mp="1xjjdqab0mxny">
                Vooral met onbekende honden was er toch vaak wel flink geblaf.
                Nu bijna niet meer. Heerlijk, wat is wandelen toch weer een
                genot. Inderdaad: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5297" data-mp="2bj2880awmahs">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5298" data-mp="1mf3y0snvqvla">
              <div className="flex items-center mb-4" data-id="element-5299" data-mp="1hhbxja96615h">
                <div className="flex text-green-500 mr-2" data-id="element-5300" data-mp="1hiwraxnntg2a">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5301" data-mp="1ve8uzujsmgvc" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5302" data-mp="13pf85dyvy5cs">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5303" data-mp="13n1hdhb8nfb1">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5304" data-mp="1cir53x05slrl">
                Voorbereid zijn op de puppy die ik krijg en weten hoe ik
                problemen voorkom. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5305" data-mp="k03puy7ug0yf">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5306" data-mp="5w65peqobsr1">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5307" data-mp="w0a5nha9m3o">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5308" data-mp="x31txmfjskn">
          <div data-id="element-5309" data-mp="on5nnvzr42at">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5310" data-mp="okb6cdc1axlm">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5311" data-mp="enet5ub6xnaq">
              <p data-id="element-5312" data-mp="jmrnf04e5wnc">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies weet hoe frustrerend het is als je hond gedrag vertoont
                dat je maar niet opgelost krijgt.
              </p>
              <p data-id="element-5313" data-mp="24a3irt0opyxw">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes mogen
                helpen bij het oplossen van probleemgedrag. Van blaffen tot
                trekken, van uitvallen tot angst. En wat ik keer op keer zie: de
                meeste problemen zijn geen trainingsproblemen. Het zijn
                communicatieproblemen.
              </p>
              <p data-id="element-5314" data-mp="1li29dwqaaqa8">
                De frustratie komt niet door een 'slechte' hond of een 'falende'
                baas. Het komt doordat baasjes en honden letterlijk twee
                verschillende talen spreken. Zodra je leert communiceren in de
                taal van je hond, verdwijnen de problemen. De strijd maakt
                plaats voor samenwerking.
              </p>
              <p data-id="element-5315" data-mp="12iwsp7slamvg">
                Daarom werk ik uitsluitend met methodes gebaseerd op vertrouwen,
                veiligheid en echte communicatie. Geen dwang, geen straf. Alleen
                liefde en begrip.
              </p>
              <p data-id="element-5316" data-mp="nxiy593irnhr">
                Dit webinar is mijn manier om deze aanpak met zoveel mogelijk
                baasjes te delen. Omdat ik geloof dat elk probleem oplosbaar is
                - als je maar weet hoe.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5317" data-mp="svaymri8chxk">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5318" data-mp="sy6zanlgpkpp" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5319" data-mp="1bmlnz48b4mnc">
        <div className="max-w-md mx-auto px-4" data-id="element-5320" data-mp="1bnn3bkwcvvav">
          <div className="p-6 rounded-3xl w-full" data-id="element-5321" data-mp="1pm38v8ihffrf">
            <div className="flex justify-center items-center" data-id="element-5322" data-mp="1pmmogiknts2a">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5323" data-mp="1ll1eb4zifrvs"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5324" data-mp="2bdxsok664zxn">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5325" data-mp="2gchdgh9105of">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5326" data-mp="2lbtz4yo5v6pf" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5327" data-mp="r06xas6uq5zj">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5328" data-mp="vzjm3iha9n4r">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5329" data-mp="34fp52qdwawd7">
            <p className="mb-2" data-id="element-5330" data-mp="30g6lbxxt8rby">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5331" data-mp="2vhvdfsr2sqwd">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5332" data-mp="3qocho22o702v" />
    </div>;
}